<template>
    <div class="container">
         <img  class="topImg" src="../../assets/images/img_ticket_top.jpg"  />
          <div class="scroll">
             <scroll v-if="couponArr.length" :data="couponArr"
                :allLoaded="allLoaded"  @pulldown="loadData" @loadUp="loadup" >
              <div  v-for="(item,index) in couponArr" :key="index" >
                  <!-- @click="goDetail(item.orderNo)" -->
                   <div class="list_box" >
                       <img v-if="item.templateType==1" class="list_box_bg" src="../../assets/images/img_ticket_center_zhifu.png"/>
                       <img v-else class="list_box_bg" src="../../assets/images/img_ticket_center_fanjin.png"/>

                       <div class="list_box_left">
                           <div v-if='item.templateType==1' :class="['list_box_left_div1', activeTab!=0 ? 'grayClass':'greenClass' ]">
                               <span class="list_box_left_span1">{{item.templateTypeName}}</span>
                           </div>
                           <div v-else :class="['list_box_left_div2', activeTab!=0 ? 'grayClass':'yellowCloss' ]">
                               <span :class="['list_box_left_span2', activeTab!=0 ? 'whiteClass':'blackClass' ]" >{{item.templateTypeName}}</span>
                           </div>
                           <div v-if="item.discountMode == '1'" class="list_box_left_body">
                                   <span  :class="['list_box_left_body_span1', activeTab!=0 ? 'grayTextClass':'redTextClass' ]" >￥</span>
                                   <span :class="['list_box_left_body_span2', activeTab!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount}}</span>
                           </div>
                            <div v-else class="list_box_left_body">
                                   <span :class="['list_box_left_body_span2', activeTab!=0 ? 'grayTextClass':'redTextClass' ]">{{item.amountDiscount/10}}</span>
                                   <span  :class="['list_box_left_body_span3', activeTab!=0 ? 'grayTextClass':'redTextClass' ]" >折</span>
                           </div>

                       </div>
                       <div class="list_box_center">
                            <span class="list_box_center_span1">{{item.name}}</span>
                            <span class="list_box_center_span2">{{item.beginTime | date}}-{{item.endTime | date}}</span>
                            <span class="list_box_center_span3">{{item.templateDescr}}</span>

                       </div>
                       <div class="list_box_right">
                        <div v-if="item.numLeave*100/item.numAll>0" class="list_box_right_body">
                            <span class="list_box_right_body_span1">剩余{{parseInt(item.numLeave*100/item.numAll)}}%</span>
                             <div class="list_box_right_body_pb">
                                <div class="list_box_right_body_pv" :style="'width:'+item.numPerson1+'%'"></div>
                            </div>
                            <div class="list_box_right_body_div2" @click="addMbBond(item)">
                                <span class="list_box_right_body_span2">立即领取</span>
                            </div>
                        </div>
                       <img v-else class="usedImg"  src="../../assets/images/img_ticket_empty.png"/>
                       </div>

                   </div>

                </div>

             </scroll>
             <no-message v-if="!couponArr.length && loaded"></no-message>
          </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Scroll from '../../components/scroll';
import NoMessage from '../../components/nomessage';
import {getMbBondActiveList ,addMbBond} from "../../utils/api";
import util from "../../utils/util";
export default {
  name: "distributionVoucher",
  components: {
      Scroll,
      NoMessage,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      activeTab:0,
      pageNo:1,
      couponArr:[],
      loaded: false,
      allLoaded: false,
      pwidth:60,
    }
  },
  filters: {
      date: function(data) {
        if (data) {
          return data.split('-').join('.')
        }
      }
    },
  created(){
      var self =this;
      this.getMbBondActiveList();
  },
   methods: {
     getMbBondActiveList(){
         var param = {
          "pageNo": this.pageNo,
          "pageSize": 10,
          "marketId": this.common.marketInfo.id,
          "type": ''
        }
        getMbBondActiveList(param).then(res => {
            if (res.res.code === 10000) {
                this.loaded =true;
                var list = res.body.mbBondActiveList;
                for(var i=0;i<list.length;i++){
                    var item =list[i];
                    if(item.numLeave*100/item.numAll<5){
                        item.numPerson1 =5
                    }else{
                        item.numPerson1 = item.numLeave*100/item.numAll;
                    }

                }
                if (this.pageNo === 1) {
                    this.couponArr =  list ;
                } else {
                    this.couponArr = this.couponArr.concat(list )
                }
                if(!list ){
                    this.allLoaded =true
                } else if(list.length%10==0){
                    this.allLoaded =false
                }else{
                    this.allLoaded =true;
                }
            }
        });

     }  ,


     loadup () {
        if (this.allLoaded) {
            return;
        }
        this.pageNo++;
        this.getMbBondActiveList();
     },
     loadData () {
        this.pageNo = 1;
        this.getMbBondActiveList();
     },
     goDetail(index){
        var path ="/distributionDetails/"+"123456";
        this.$router.push({
          path: path
        })
    },
    addMbBond(list) {

        var param = {
            "memberCode": this.common.userInfo.memberCode, //head里面传
            "activeId": list.id,
            "marketId": this.common.marketInfo.id,
            "templateId": list.templateId,
            "beginTime": list.tempBeginTime.split('-').join(''),
            "endTime": list.tempEndTime.split('-').join('')
        }
        util.showLoading("兑换中...");
        addMbBond(param).then(res => {
          util.hideLoading();
          if (res.res.code === 10000) {
                util.showToast("领取成功",3000)
                this.loadData();
          } else {
                util.showToast(res.res.msg)
          }
        })
      }
   }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    height: 100vh;
    position: relative;
    background:rgba(255,255,255,1);
    .flex(column);
    .scroll {
        flex: 1;
        height: 500px;
    }
}
.topImg{
    width: 100%;
    height: 282px;
}

.list_box{
    height: 200px;
    width: 94.6%;
    // background-color: aqua;
    margin-top: 20px;
    margin-left: 20px;
    position: relative;
    flex-direction: row;

    .list_box_bg{
        left: 0;
        top: 0;
        position: absolute;
        height: 200px;
        width: 100%;
        z-index: 1;
    }
    .list_box_left{
        left: 0;
        top:0;
        position: absolute;
        height: 200px;
        width: 25%;
        // background-color: antiquewhite;
        z-index: 100;
        flex-direction: column;
        .list_box_left_div1{
            display: flex;
            width:100px;
            height:40px;
          //  background:rgba(22,188,132,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span1{
                text-align: center;
                font-size:24px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:24px;
            }

        }
        .list_box_left_div2{
            display: flex;
            width:100px;
            height:40px;
           // background:rgba(246,196,0,1);
            border-radius:8px 0px 8px 0px;
            justify-content: center;
            justify-items: center;
            align-items: center;
            .list_box_left_span2{
                text-align: center;
                font-size:24px;
                font-weight:500;
                line-height:24px;
            }

        }
          .list_box_left_body{
                width: 100%;
                display: flex;
                margin-top: 30px;
                justify-content: center;
                flex-direction: row;
                align-items: flex-start;
                .list_box_left_body_span1{
                    height:40px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:40px;
                }
                .list_box_left_body_span2{
                    height:60px;
                    font-size:56px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:60px;
                }
                .list_box_left_body_span3{
                    margin-top: 30px;
                    height:28px;
                    font-size:28px;
                    font-weight:500;
                    // color:rgba(252,63,86,1);
                    line-height:28px;
                }

            }

    }
    .list_box_center{
        right: 25%;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 50%;
        z-index: 100;
        .list_box_center_span1{
            margin-left: 20px;
            margin-top: 28px;
            display: flex;
            width: 90%;
            height:42px;
            font-size:30px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:42px;
        }
        .list_box_center_span2{
            margin-left: 20px;
            margin-top: 30px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;

        }
        .list_box_center_span3{
            margin-left: 20px;
            margin-top: 4px;
            display: flex;
            width: 90%;
            height:28px;
            font-size:22px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:28px;
        }
    }
    .list_box_right{
        right: 0;
        top: 0;
        position: absolute;
        flex-direction: column;
        height: 200px;
        width: 25%;
        display: flex;
        z-index: 100;
        justify-content: center;
        align-items: center;
        .list_box_right_body{
            height: 200px;
            width: 100%;
            align-items: center;
            display: flex;
            flex-direction: column;
           // background-color: blue;
            .list_box_right_body_span1{
                margin-top: 28px;
                height:34px;
                font-size:24px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:34px;
            }
            .list_box_right_body_pb{
                margin-top: 20px;
                display: flex;
                width:120px;
                height:12px;
                background:rgba(234,234,234,1);
                border-radius:6px;
                .list_box_right_body_pv{
                    // width:50%;
                    height:12px;
                    background:rgba(252,63,86,1);
                    border-radius:6px;
                }
            }
            .list_box_right_body_div2{
                margin-top: 26px;
                width:136px;
                height:52px;
                background:rgba(252,63,86,1);
                border-radius:4px;
                display: flex;
                justify-content: center;
                align-items: center;
                .list_box_right_body_span2{
                    height:32px;
                    font-size:26px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    line-height:32px;
                }
            }


        }
        .usedImg{
            // position: absolute;
            // z-index: 101;
            // right: 26px;
            // top: 40px;
            width: 120px;
            height: 120px;
        }
    }
    .grayClass{
        background: #DADADA;
    }
    .greenClass{
        background:rgba(22,188,132,1)
    }
    .yellowCloss{
        background:rgba(246,196,0,1);
    }
    .blackClass{
        color:#333333;
    }
    .whiteClass{
        color: #ffffff;
    }
    .grayTextClass{
        color: #999999;
    }
    .redTextClass{
        color:rgba(252,63,86,1);
    }

    .useDiv{
        right: 26px;
        top: 120px;
        position: absolute;
        width:128px;
        height:52px;
        display: flex;
        background:rgba(255,255,255,1);
        border-radius:4px;
        justify-content: center;
        justify-items: center;
        align-items: center;
        z-index: 101;
        .useDiv_span{
            height:32px;
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,1);
            line-height:32px;
        }
    }


    //pop view


}

</style>